@if (summaries?.length) {
  <ds-accordion-category title="{{ title }} ({{ summaries.length }})" [icon]="icon" [isOpen]="true">
    @for (summary of summaries; track summary; let isFirst = $first) {
      <div class="no-detail">
        <div class="no-detail__item">
          @if (isFirst) {
            <div class="header"><strong>Policy Number</strong></div>
          }
          <div class="content policy__link">
            Policy {{ summary.policyNumber | prettyPolicyNum }}
          </div>
        </div>
        <div class="no-detail__item">
          @if (isFirst) {
            <div class="header">
              <strong>{{ isLife ? 'Effective Date' : 'Policy Term' }}</strong>
            </div>
          }
          @if (isLife) {
            <div class="content">
              {{ summary.effectiveDate | date: 'MM/dd/YY' }}
            </div>
          } @else {
            <div class="content">
              {{ summary.effectiveDate | date: 'MM/dd/YY' }} -
              {{ summary.endEffectiveDate | date: 'MM/dd/YY' }}
            </div>
          }
        </div>
        <div class="no-detail__action">
          @if (isFirst) {
            <div class="header">&nbsp;</div>
          }
          <button
            ds-button
            type="button"
            class="-outline-white md-float-right"
            data-cy="policySummaryViewDetails"
            (click)="detailButtonClicked.emit()"
          >
            View Details
          </button>
        </div>
      </div>
    }
  </ds-accordion-category>
}
